import { selectIsEtazhiBlackFridayEnabled } from './selectIsEtazhiBlackFridayEnabled';
import { dealTypeFromJsonQuery, offerTypeFromJsonQuery } from '../../../packages/JsonQuery';
import { FOfferType, FDealType } from '../../../packages/JsonQuery/types';
import { selectJsonQuery } from '../results';

import type { IAppState } from 'shared/common/state';

export const selectIsEtazhiBlackFridayPromoVisible = (state: IAppState): boolean => {
  const isEnabled = selectIsEtazhiBlackFridayEnabled(state);

  if (!isEnabled) {
    return false;
  }

  const jsonQuery = selectJsonQuery(state);
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const dealType = dealTypeFromJsonQuery(jsonQuery);

  // Только вторичка продажа квартир
  const isFlatSale = offerType === FOfferType.FlatOld && dealType === FDealType.Sale;

  return isFlatSale;
};
